<script setup>
    import Layout from "@/layouts/main.vue";
    import PageHeader from "@/components/page-header";  
    import "@suadelabs/vue3-multiselect/dist/vue3-multiselect.css";
    import { required, helpers } from "@vuelidate/validators";
    import useVuelidate from "@vuelidate/core";
    import { computed, ref, reactive, onUnmounted } from 'vue';
    import { useStore } from 'vuex';

    const state = reactive({
        name: '',
        description: '',
    });

    const rules = computed(() => ({
        name: {
            required: helpers.withMessage("Name is required", required),
        }
    }));

    const store = useStore();
    const v$ = useVuelidate(rules, state);

    const title = ref("Roles");
    const items = ref([
        {
            text: "Home",
            href: "/",
        },
        {
            text: "User Management",
            href: "/user-management/roles/list",
            active: true
        },
        {
            text: "Add New Role",
            active: true,
        }
    ]);

    const submitted = ref(false);
    const loading = computed(() => store.state.globals.loading);
    const notification = computed(() => store ? store.state.notification : null)

    const createRole = async () => {
        submitted.value = true
        v$.value.$touch();

        if (v$.value.$invalid) return;
        await store.dispatch('role/createRole', state);
    }

    onUnmounted(() => {
        store.dispatch('notification/clear', null, { root: true });
    })
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
        <div class="col lg-12">
            <b-overlay :show="loading">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title mb-0">Add New Role</h4>
                    </div>
                    <div class="card-body">
                        <div v-if="notification.type === 'danger' && notification.messages.length > 0">
                            <b-alert v-for="(message, index) in notification.messages" :key="index"
                                show variant="danger" class="fade show" role="alert">
                                {{ message }}
                            </b-alert>
                        </div>

                        <div v-if="notification.type === 'success' && notification.messages.length > 0">
                            <b-alert v-for="(message, index) in notification.messages" :key="index"
                                show variant="danger" class="fade show" role="alert">
                                {{ message }}
                            </b-alert>
                        </div>

                        <form @submit.prevent="createRole" class="mx-2">
                            <div class="row">
                                <p class="fs-6 text text-decoration-underline">Role Information</p>
                                <div class="col-md-6">
                                    <div class="mb-3">
                                        <label for="name" class="form-label required">Name</label> 
                                        <input 
                                            autofocus
                                            :class="{ 'is-invalid': submitted && v$.name.$error }"
                                            v-model="state.name" class="form-control" type="text" placeholder="Enter name..." id="name" />
                                        <div
                                            v-for="item of v$.name.$errors"
                                            :key="item.$uid"
                                            class="invalid-feedback"
                                        >
                                            <span v-if="item.$message">{{ item.$message }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="mb-3">
                                        <label for="description" class="form-label">Description</label> 
                                        <textarea
                                            v-model="state.description" class="form-control" placeholder="Enter description..." id="description"></textarea>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="text-end">
                                        <router-link to="/user-management/roles/list" type="submit" class="btn btn-danger mr-3">
                                            <i class="ri-close-fill fs-4 mr-1 valign-middle"></i>
                                            Cancel
                                        </router-link>
                                        <button type="submit" class="btn btn-success">
                                            <i class="ri-save-2-fill fs-4 mr-1 valign-middle"></i>
                                            Add Role
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                </div>
                </div>
            </b-overlay>
        </div>
    </div>
  </Layout>
</template>